import { Component, EventEmitter, Injector, Input } from '@angular/core';
import { ItemFinderComponent } from '../item-finder.component';
import { ListColumn, ListDataColumn } from '../../../ui/Data/ListColumn';
import { BaseNode } from '../../../ui/Node/BaseNode';
import { LookupGetService } from '../../../service/lookup-service/lookup-get.service';

@Component({
  selector: 'app-item-finder-tree-model',
  templateUrl: './item-finder-tree-model.component.html',
  styleUrl: './item-finder-tree-model.component.scss'
})
export class ItemFinderTreeModelComponent extends ItemFinderComponent {
  override selectedNode: any;

  @Input() override doAction = new EventEmitter<any>();
  constructor(override injector: Injector) {
    super(injector);
  }

  override sortBy(column: ListColumn) {
    this.sortOrder = column.getSourceName() === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = column.getSourceName();
    this.selectedNode.children = [...this.selectedNode.children.sort((a: any, b: any) => {
      let result = 0;

      const valueA = a.data.model[column.getSourceName()];
      const valueB = b.data.model[column.getSourceName()];

      if (column.getDataType() === ListDataColumn.DATE || column.getDataType() === ListDataColumn.DATETIME) {
        const timeA = new Date(valueA).getTime(); // Convert to timestamp
        const timeB = new Date(valueB).getTime(); // Convert to timestamp
        result = timeA < timeB ? -1 : timeA > timeB ? 1 : 0;
      } else if (column.getDataType() === ListDataColumn.LOOKUP) {
        const valueA = this.injector.get(LookupGetService).retrieveValueFromCache(column.getLookup()!, a[column.getSourceName()]);
        const valueB = this.injector.get(LookupGetService).retrieveValueFromCache(column.getLookup()!, b[column.getSourceName()]);
        result = String(valueA).localeCompare(String(valueB)); 
      } else {
        // Case‑insensitive text compare
        const strA = (valueA ?? '').toString().toLowerCase();
        const strB = (valueB ?? '').toString().toLowerCase();
        result = String(strA).localeCompare(String(strB)); 
      } 
        return result * this.sortOrder;
  })];
}

  override select($event: any, selectedNode: BaseNode) {
  selectedNode.checked = !selectedNode.checked;
}

sortByNum() {
  this.sortProperty = "-1";
  this.sortOrder = (this.sortOrder * -1);
  this.selectedNode.children = [...this.selectedNode.children.sort((a: BaseNode, b: BaseNode) => {
    let result = 0;
    const numA: number = +a.num;
    const numB: number = +b.num;
    if (numA < numB) {
      result = -1;
    }
    if (numA > numB) {
      result = 1;
    }

    return result * this.sortOrder;
  })];
}
  
}
